import React from 'react';

import Loadable from 'react-loadable';

const LazyDirectory = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_directory-page" */ './main'
		),
	loading: () => null,
});
LazyDirectory.displayName = 'lazy(LazyDirectory)';

/**
 * In a new directory page we need to pass full path in order to keep
 * the component updated when doing manipulations with route
 * programmatically.
 */
const DirectoryRoute = (): React.JSX.Element => {
	return <LazyDirectory />;
};

export default DirectoryRoute;
